<template>
  <div v-loading="loading">
    <div>
      <el-row :gutter="20" style="margin-top: -8px;">
        <jr-col :data-show="firstCol" :data="baseInfoData" />
        <jr-col :data-show="secondCol" :data="baseInfoData" />
        <jr-col :data-show="thirdCol" :data="baseInfoData" />
      </el-row>
    </div>
    <div class="main-cont-item">
      <div class="flex flex-justify-between flex-align-center">
        <h2 class="title-text">账户余额</h2>
        <el-select
          v-model="currentWallet"
          placeholder="请选择"
          :size="formSize"
          @change="selectWalletChange"
          style="width: 250px"
        >
          <el-option
            v-for="item in (baseInfoData.walletInfoRsp)"
            :key="item.thirdAccountNo"
            :label="`${item.channelName} ${item.thirdAccountNo}`"
            :value="item.thirdAccountNo"
          >
            <span style="float: left">{{ item.channelName }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.thirdAccountNo }}</span>
          </el-option>
        </el-select>
      </div>
      <el-row :gutter="20" style="margin-top: 8px;">
        <jr-col :data-show="WalletInfoFirstCol" :data="currentWalletInfo" />
        <jr-col :data-show="WalletInfoSecondCol" :data="currentWalletInfo" />
        <jr-col :data-show="WalletInfoThirdCol" :data="currentWalletInfo" />
      </el-row>
    </div>
  </div>
</template>

<script>
import { getCustomerBaseinfo } from '@/api/servicer';

export default {
  name: 'BaseInfo',
  props: {
    // 客户财务编号
    customerNo: {
      tyoe: String,
    },
  },
  data() {
    return {
      loading: false,
      baseInfoData: {},
      baseInfoItem: [],
      firstCol: [
        { label: '统一社会信用编号:', prop: 'regCode' },
        { label: '服务商全称:', prop: 'businessName' },
        { label: '业务客户编号:', prop: 'businessNo' },
        { label: '平台注册时间:', prop: 'registerTime', filters: 'formatTime' },
      ],
      secondCol: [
        { label: '公司类型:', prop: 'companyType' },
        { label: '企业法人:', prop: 'ledgerPerson' },
        { label: '归属业务:', prop: 'businessSourceDesc' },
        { label: '注册地址:', prop: 'registerAddress' },
      ],
      thirdCol: [
        { label: '经营状态:', prop: 'companyState' },
        { label: '成立日期:', prop: 'establishTime', filters: 'formatTime' },
        { label: 'BD:', prop: 'bdName' },
        { label: '经营范围:', prop: 'businessScope' },
      ],
      WalletInfoFirstCol: [
        { label: '资金账户余额:', prop: 'fundAccountAmount', filters: 'toFenThousandsAndFloat(¥)' },
        { label: '手续费余额:', prop: 'feeAccountAmount', filters: 'toFenThousandsAndFloat(¥)' },
      ],
      WalletInfoSecondCol: [
        { label: '待分账账户余额:', prop: 'divideAccountAmount', filters: 'toFenThousandsAndFloat(¥)' },
      ],
      WalletInfoThirdCol: [
        { label: '待结算账户余额:', prop: 'settleAccountAmount', filters: 'toFenThousandsAndFloat(¥)' },
      ],
      currentWallet: '',
      currentWalletInfo: {},
    };
  },
  methods: {
    init() {
      this._getCustomerBaseinfo();
    },
    _getCustomerBaseinfo() {
      this.loading = true;
      getCustomerBaseinfo({
        customerNo: this.customerNo,
        principalType: 1, // 0普通商户 1服务商
      }).then((res) => {
        const { data = {} } = res;
        this.baseInfoData = { ...data };
        if (data.walletInfoRsp && data.walletInfoRsp.length) {
          this.currentWalletInfo = { ...data.walletInfoRsp[0] };
          this.currentWallet = data.walletInfoRsp[0].thirdAccountNo;
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.baseInfoData = {};
      });
    },
    selectWalletChange(val) {
      const current = this.baseInfoData.walletInfoRsp.filter((item) => item.thirdAccountNo === val);
      this.currentWalletInfo = current.length ? current[0] : {};
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-form-item {
    margin-bottom: 0 !important;
  }
  .main-cont-item {
    border-bottom: 0;
    margin-top: 30px;
  }
}
</style>
